import { adminFetch } from "./_client";
import type {
  CommsFlowsListResponse,
  CommsFlowsCallSite,
  CommsFlowsDetail,
  CommsFlowsGoLiveStatus,
} from "./types";

export function fetchCommsFlowsList(token: string) {
  return adminFetch<CommsFlowsListResponse>("/admin/communications/flows", token);
}

export function fetchCommsFlowsDetail(token: string, id: string) {
  return adminFetch<CommsFlowsDetail>(`/admin/communications/flows/${encodeURIComponent(id)}`, token);
}

export function fetchCommsFlowsUnifiedMermaid(token: string) {
  return adminFetch<{ mermaid: string; scannedAt: string }>("/admin/communications/flows/all/mermaid", token);
}

export function fetchCommsFlowsOrphans(token: string) {
  return adminFetch<{ orphans: Array<{ kind: string; templateId: string; reason: string }>; scannedAt: string }>("/admin/communications/flows/orphans", token);
}

export function fetchCommsFlowsAdHoc(token: string) {
  return adminFetch<{ adHoc: CommsFlowsCallSite[]; scannedAt: string }>("/admin/communications/flows/ad-hoc", token);
}

export function rescanCommsFlows(token: string) {
  return adminFetch<{ ok: true; scannedAt: string; filesScanned: number; flowCount: number; adHocCount: number; orphanedCount: number }>(
    "/admin/communications/flows/rescan", token, { method: "POST" },
  );
}

/**
 * Task #4906 — engage/disengage the go-live comms kill-switch. Persists a
 * runtime override the gate reads at call time; returns the resulting
 * effective go-live status.
 */
export function setGoLiveCommsPause(token: string, paused: boolean) {
  return adminFetch<{ ok: true; paused: boolean; goLive: CommsFlowsGoLiveStatus }>(
    "/admin/communications/flows/go-live/pause",
    token,
    { method: "POST", body: JSON.stringify({ paused }) },
  );
}
